import PropTypes from 'prop-types';
import './styles.css';

const PaddedCardGroup = ({ children, className }) => {
  return <div className={`padded-card-group ${className}`}>{children}</div>;
};

PaddedCardGroup.defaultProps = {
  className: '',
};

PaddedCardGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default PaddedCardGroup;
